import { defineComponent as _defineComponent } from 'vue'
import { ITicketPurchased } from '@/features/tickets/types'
import BKButton from '@/components/AppShared/BKButton.vue'
import { centsToDollars } from '@/services/currency'
import { ref } from 'vue'
import { AxiosError } from 'axios'
import { useRefundTicketMutation } from '@/features/tickets/api/queries'


export default /*#__PURE__*/_defineComponent({
  __name: 'RefundTicketInterface',
  props: {
    currentTicket: null
  },
  emits: ["close", "show-tier-change-interface"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'show-tier-change-interface'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  currentTicket: ITicketPurchased
};





const refundMutation = useRefundTicketMutation()

const handleShowChangeTier = () => {
  emit('show-tier-change-interface')
  emit('close')
}

const showSuccessMessage = ref(false)
const errorMessage = ref('')

const handleRefund = () => {
  if (refundMutation.isPending.value) return
  errorMessage.value = ''
  refundMutation.mutate(props.currentTicket.id, {
    onSuccess: () => {
      showSuccessMessage.value = true
    },
    onError: (err) => {
      // Surface backend refusals (e.g. policy window, already refunded) instead
      // of silently showing nothing. The success message must only appear on a
      // genuine success.
      const axiosErr = err as AxiosError<{ message?: string }>
      errorMessage.value = axiosErr.response?.data?.message || axiosErr.message || 'Refund failed. Please try again.'
    },
  })
}

return { __sfc: true,props, emit, refundMutation, handleShowChangeTier, showSuccessMessage, errorMessage, handleRefund, BKButton, centsToDollars }
}

})